import { useEffect, useRef } from "react";
import { moveImageBox } from "../helpers/animations";
import Map from "./Map";

export default function MapWithBox({
  fullMobile = false,
  location = "none",
  className = "",
  children,
  ...rest
}) {
  const refMap = useRef();
  const refBox = useRef();

  useEffect(() => {
    const handleScroll = () => {
      if (refMap.current && refBox.current) {
        // moveImageBox(refMap, refBox, -0.03, 0.04);
        moveImageBox(refMap, refBox, -0.035, 0.025);
      }
    };

    window?.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window?.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div
        className="hidden md:block absolute w-[50%] aspect-[10/11] top-2/4 md:top-0 left-1 md:-left-[25%] bg-white shadow-lg rounded-md ease-out transition-transform duration-500"
        ref={refBox}
      />
      <div ref={refMap}>
        <Map
          fullMobile={fullMobile}
          location={location}
          className={className}
          {...rest}
        />
      </div>
    </>
  );
}
